export default {
  ESTADO: 'Maranhão',
  SISTEMA: 'SICARF-MA',
  SIGLA_ESTADO: 'MA',
  ORGAO: 'ITERMA',
  LOGO: 'static/logo-ma.png',
  SHAPE_ESTADO: 'municipiosMaranhao.json',
  COORDENADAS_ESTADO: [-5.5941182188847876, -45.62622070312499],
  UTILIZA_ARCGIS: false
}



// WEBPACK FOOTER //
// ./src/constants/ma/dadosEstado/geral.js